import { DestroyRef, Directive, ElementRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WindowRef } from '@spartacus/core';
import { filter } from 'rxjs';
import { ScrollIntoViewIds } from './scroll-into-view-ids';
import { ScrollIntoViewService } from './scroll-into-view.service';

@Directive({
  selector: '[sdScrollIntoView]',
  standalone: true,
})
export class ScrollIntoViewDirective implements OnInit {
  @Input('sdScrollIntoView') id: ScrollIntoViewIds;

  constructor(
    private readonly el: ElementRef,
    private readonly winRef: WindowRef,
    private readonly scrollIntoViewService: ScrollIntoViewService,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    if (this.winRef.isBrowser()) {
      this.scrollIntoViewService.scrollIntoView$
        .pipe(
          filter((id) => id === this.id),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(() => this.scrollToElement());
    }
  }

  private scrollToElement(): void {
    const element = this.el.nativeElement;
    if (element) {
      const rect = element.getBoundingClientRect();
      const currentY = this.winRef.nativeWindow?.scrollY ?? 0;
      const targetY = currentY + rect.top - element.clientHeight / 8;
      this.winRef.nativeWindow?.scrollTo({ top: targetY, behavior: 'smooth' });
    }
  }
}
